export default "__VITE_ASSET__BE2q074e__"